<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
     
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="4">
        <v-row justify="center">
          <v-btn color="success" small fab dark>
            <v-icon>{{showIcon}}</v-icon>
          </v-btn>
        </v-row>
      </v-col>
      <v-col cols="12" md="8">
        <v-text-field
          solo
          :label="$vuetify.lang.t('$vuetify.custom.entryKeyWordSelect')"
          append-icon="mdi-magnify"
          @keyup.enter.native="search"
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <v-responsive
      class="overflow-y-auto"
      :max-height="height"
    >
      <v-row>
        <v-col
          v-for="(icon,i) in icons"
          :key="i"
        >
          <v-lazy>
          <v-tooltip
            content-class="top"
            top
          >
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                @click="selected(icon)"
              >
                {{ icon }}
              </v-icon>
            </template>
            <span>{{ icon }}</span>
          </v-tooltip>
          </v-lazy>
        </v-col>
      </v-row>
    </v-responsive>
  </v-container>
</template>
<style></style>
<script>
  import iconArr from '@/store/icon'

  export default {
    name: 'icon-selector',
    model: {
      prop: 'icon',
      event: 'parent-event'
    },
    props:{
      height:{
        default:400,
      },
      icon:String
    },
    data() {
      return {
        icons: [],
        iconsAll: iconArr.icons,
      }
    },
    methods:{
      search(data){
        let keywords = data.target.value;
        if(keywords == ""){
          this.icons = this.iconsAll;
          return;
        }
        let len = this.iconsAll.length;
        this.icons = [];
        let reg = new RegExp(keywords);
        for(let i=0;i<len;i++){
          //如果字符串中不包含目标字符会返回-1
          if(this.iconsAll[i].match(reg)){
            this.icons.push(this.iconsAll[i]);
          }
        }
      },
      selected(data){
        this.$emit('parent-event',data)
        this.$emit('change')
      }
    },
    computed:{
      showIcon(){
        return this.icon
      }
    },
    created(){
      this.icons = this.iconsAll;
    }
  }
</script>
